import { CalendarCheck } from "lucide-react";

const AttendanceTileDesign = {
  id: "attendance",
  icon: CalendarCheck,
  label: "Attendance",
  background: "#3F7A66",
  color: "#ffffff",
};

export default AttendanceTileDesign;
